import React, { useState, useEffect } from 'react';
import {
  Box,
  HStack,
  Text,
  CloseButton,
  Icon,
  Slide,
} from '@chakra-ui/react';
import { FaHardHat } from 'react-icons/fa';

const UnderConstructionBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem('construction_banner_dismissed');
    if (!dismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem('construction_banner_dismissed', 'true');
  };

  return (
    <Slide direction="top" in={isVisible} style={{ zIndex: 9999 }}>
      <Box
        bg="orange.400"
        color="white"
        py={3}
        px={4}
        shadow="lg"
      >
        <HStack justify="center" spacing={3} maxW="container.xl" mx="auto">
          <Icon as={FaHardHat} boxSize={5} />
          <Text fontSize="sm" fontWeight="semibold" textAlign="center">
            We're currently improving SRS. You can browse the site, but sign-in and sign-up are temporarily unavailable.
          </Text>
          <CloseButton size="sm" onClick={handleClose} color="white" _hover={{ bg: 'orange.500' }} />
        </HStack>
      </Box>
    </Slide>
  );
};

export default UnderConstructionBanner;
